import { RootState } from '../rootReducer';

export const selectTranslation = (state: RootState) => state.translation.translation.translation;
